import { Card, Flex, Space, Divider, Typography, Row, Col } from "antd";
import { Navbar } from "../../components/navbar";
import {
  SafetyOutlined,
  GlobalOutlined,
  BookOutlined,
  RocketOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import { FooterSection2 } from "../../layouts/footer_section_2";
import { Head } from "@inertiajs/react";
import { OrgCard } from "./org_card";
import { AdvisorCard } from "./advisor_card";

const { Title, Text, Paragraph } = Typography;

const ACCENT = "#4096ff";
const TEXT_PRIMARY = "#1a2332";
const TEXT_SECONDARY = "#556678";

const DataMisi = [
  {
    text: "Mengembangkan platform edukasi yang interaktif, menarik, dan mudah digunakan oleh anak usia dini.",
    icon: <RocketOutlined />,
  },
  {
    text: "Membantu guru, sekolah, dan institusi pendidikan dalam menyampaikan materi pembelajaran secara efektif dan menyenangkan.",
    icon: <BookOutlined />,
  },
  {
    text: "Mengintegrasikan pembelajaran dan evaluasi dalam satu sistem digital yang mendukung proses belajar yang aktif.",
    icon: <CheckCircleFilled />,
  },
  {
    text: "Menumbuhkan kesadaran, keterampilan, dan kesiapan anak melalui pendekatan belajar berbasis bermain dan teknologi.",
    icon: <SafetyOutlined />,
  },
  {
    text: "Memperluas akses pendidikan dengan bekerja sama dengan sekolah dan berbagai institusi pendidikan.",
    icon: <GlobalOutlined />,
  },
];

function OrgChart({ anggota }) {
  const findByName = (searchName) =>
    anggota.find((a) =>
      a.nama.toLowerCase().includes(searchName.toLowerCase())
    );

  const ceo = findByName("Aziizah");

  const directReports = [
    findByName("Anin"),
    findByName("Nadya"),
    findByName("Maharani"),
    findByName("Thorik") || findByName("Atthariq"),
    findByName("Izan") || findByName("Mochamad"),
  ].filter(Boolean);

  const subReports = [
    findByName("Imut") || findByName("Fatih"),
    findByName("Avries") || findByName("Rayhan"),
  ].filter(Boolean);

  const izzanIndex = directReports.findIndex(
    (a) =>
      a?.nama?.toLowerCase().includes("izan") ||
      a?.nama?.toLowerCase().includes("mochamad")
  );

  const LINE_COLOR = "#d0daea";
  const LINE_THICKNESS = 2;

  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        paddingBottom: 24,
        WebkitOverflowScrolling: "touch",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: 1150,
          padding: "0 24px",
          gap: 0,
        }}
      >
        {ceo && <OrgCard anggota={ceo} size="lg" highlight />}

        <div
          style={{ width: LINE_THICKNESS, height: 40, background: LINE_COLOR }}
        />

        <div style={{ position: "relative", width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 0,
              alignItems: "flex-start",
              position: "relative",
            }}
          >
            {directReports.map((person, idx) => {
              const isFirst = idx === 0;
              const isLast = idx === directReports.length - 1;
              const isIzzan = idx === izzanIndex;
              const hasSubReports = isIzzan && subReports.length > 0;

              return (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: hasSubReports ? 2.5 : 1,
                    minWidth: hasSubReports ? 380 : 190,
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: 40,
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                    }}
                  >
                    {!isFirst && (
                      <div
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          width: "50%",
                          height: LINE_THICKNESS,
                          background: LINE_COLOR,
                        }}
                      />
                    )}
                    {!isLast && (
                      <div
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          width: "50%",
                          height: LINE_THICKNESS,
                          background: LINE_COLOR,
                        }}
                      />
                    )}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: LINE_THICKNESS,
                        height: "100%",
                        background: LINE_COLOR,
                      }}
                    />
                  </div>

                  <OrgCard anggota={person} size="md" highlight={isIzzan} />

                  {hasSubReports && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          width: LINE_THICKNESS,
                          height: 32,
                          background: LINE_COLOR,
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          gap: 0,
                          alignItems: "flex-start",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        {subReports.map((sub, si) => {
                          const isSubFirst = si === 0;
                          const isSubLast = si === subReports.length - 1;
                          return (
                            <div
                              key={si}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                flex: 1,
                              }}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  height: 32,
                                }}
                              >
                                {!isSubFirst && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      left: 0,
                                      top: 0,
                                      width: "50%",
                                      height: LINE_THICKNESS,
                                      background: LINE_COLOR,
                                    }}
                                  />
                                )}
                                {!isSubLast && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: 0,
                                      top: 0,
                                      width: "50%",
                                      height: LINE_THICKNESS,
                                      background: LINE_COLOR,
                                    }}
                                  />
                                )}
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: LINE_THICKNESS,
                                    height: "100%",
                                    background: LINE_COLOR,
                                  }}
                                />
                              </div>
                              <OrgCard anggota={sub} size="sm" />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

function About({ data_image_team }) {
  const advisorGroup = data_image_team?.find((g) =>
    g.kategori?.toLowerCase().includes("penasihat")
  );
  const operationalGroup = data_image_team?.find((g) =>
    g.kategori?.toLowerCase().includes("pelaksana")
  );

  return (
    <>
      <Head>
        <title>Kidversa - About</title>
      </Head>
      <Flex
        vertical
        align="center"
        style={{
          minHeight: "100vh",
          background:
            "linear-gradient(180deg, #f8fafc 0%, #eef2f7 50%, #ffffff 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 80,
            right: -120,
            width: 400,
            height: 400,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(64,150,255,0.08) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 120,
            left: -100,
            width: 350,
            height: 350,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(139,92,246,0.06) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />

        <Navbar />

        <main
          style={{
            width: "100%",
            maxWidth: 1200,
            margin: "0 auto",
            padding: "120px 24px 80px",
          }}
        >
          <Space
            direction="vertical"
            align="center"
            size="small"
            style={{ width: "100%", marginBottom: 64 }}
          >
            <Title
              level={1}
              style={{
                margin: 0,
                fontSize: "clamp(32px, 5vw, 48px)",
                fontWeight: 800,
                color: TEXT_PRIMARY,
                textAlign: "center",
                fontFamily: "'Quicksand', sans-serif",
                letterSpacing: "-0.02em",
              }}
            >
              Tentang <span style={{ color: ACCENT }}>Kidversa</span>
            </Title>
            <Paragraph
              style={{
                maxWidth: 600,
                textAlign: "center",
                color: TEXT_SECONDARY,
                fontSize: 16,
                marginTop: 16,
                fontFamily: "'Quicksand', sans-serif",
              }}
            >
              Platform pembelajaran interaktif untuk pendidikan anak usia dini yang dirancang untuk mendukung proses belajar yang lebih menyenangkan dan efektif.
            </Paragraph>
          </Space>

          <Row justify="center" style={{ marginBottom: 80 }}>
            <Col xs={24} lg={20} xl={18}>
              <Card
                bordered={false}
                style={{
                  borderRadius: 24,
                  background: "#ffffff",
                  boxShadow: "0 4px 24px rgba(0, 0, 0, 0.06)",
                  textAlign: "center",
                }}
                bodyStyle={{ padding: "48px 40px" }}
              >
                <Space direction="vertical" size="large" align="center">
                  <div>
                    <Text
                      strong
                      style={{
                        color: ACCENT,
                        fontSize: 14,
                        textTransform: "uppercase",
                        letterSpacing: "0.15em",
                        fontFamily: "'Quicksand', sans-serif",
                      }}
                    >
                      Visi Kami
                    </Text>
                    <Title
                      level={2}
                      style={{
                        margin: "12px 0 0",
                        color: TEXT_PRIMARY,
                        fontFamily: "'Quicksand', sans-serif",
                        fontWeight: 700,
                      }}
                    >
                      Mewujudkan Generasi Tangguh
                    </Title>
                  </div>
                  <Divider
                    style={{
                      margin: "8px 0",
                      minWidth: 60,
                      width: 60,
                      borderColor: ACCENT,
                      opacity: 0.3,
                    }}
                  />
                  <Paragraph
                    style={{
                      margin: 0,
                      fontSize: 18,
                      lineHeight: 1.8,
                      color: TEXT_SECONDARY,
                      fontFamily: "'Quicksand', sans-serif",
                      maxWidth: 700,
                    }}
                  >
                    Mewujudkan generasi anak yang cerdas, kreatif, dan siap menghadapi berbagai situasi melalui pembelajaran interaktif berbasis teknologi sejak usia dini.
                  </Paragraph>
                </Space>
              </Card>
            </Col>
          </Row>

          <Space
            direction="vertical"
            size="large"
            style={{ width: "100%", marginBottom: 80 }}
          >
            <Space
              direction="vertical"
              align="center"
              size="small"
              style={{ width: "100%" }}
            >
              <Text
                strong
                style={{
                  color: ACCENT,
                  fontSize: 14,
                  textTransform: "uppercase",
                  letterSpacing: "0.15em",
                  fontFamily: "'Quicksand', sans-serif",
                }}
              >
                Misi Kami
              </Text>
              <Title
                level={2}
                style={{
                  margin: 0,
                  color: TEXT_PRIMARY,
                  fontFamily: "'Quicksand', sans-serif",
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                Langkah-langkah Strategis
              </Title>
            </Space>
            <Row gutter={[24, 24]} justify="center">
              {DataMisi.map((item, index) => (
                <Col xs={24} sm={12} lg={8} key={index}>
                  <Card
                    bordered={false}
                    hoverable
                    style={{
                      height: "100%",
                      borderRadius: 16,
                      background: "#ffffff",
                      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)",
                      transition: "all 0.3s ease",
                    }}
                    bodyStyle={{ padding: 28 }}
                  >
                    <Space direction="vertical" size="middle">
                      <div
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: 12,
                          background: `${ACCENT}15`,
                          color: ACCENT,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 20,
                        }}
                      >
                        {item.icon}
                      </div>
                      <Text
                        strong
                        style={{
                          fontSize: 16,
                          color: TEXT_PRIMARY,
                          fontFamily: "'Quicksand', sans-serif",
                          display: "block",
                          marginBottom: 8,
                        }}
                      >
                        Misi {index + 1}
                      </Text>
                      <Paragraph
                        style={{
                          margin: 0,
                          fontSize: 14,
                          lineHeight: 1.7,
                          color: TEXT_SECONDARY,
                          fontFamily: "'Quicksand', sans-serif",
                        }}
                      >
                        {item.text}
                      </Paragraph>
                    </Space>
                  </Card>
                </Col>
              ))}
            </Row>
          </Space>

          <Divider style={{ margin: "24px 0 64px", opacity: 0.5 }} />

          <Space direction="vertical" size={64} style={{ width: "100%" }}>
            <Space
              direction="vertical"
              align="center"
              size="small"
              style={{ width: "100%" }}
            >
              <Text
                strong
                style={{
                  color: ACCENT,
                  fontSize: 14,
                  textTransform: "uppercase",
                  letterSpacing: "0.15em",
                  fontFamily: "'Quicksand', sans-serif",
                }}
              >
                Tim Kami
              </Text>
              <Title
                level={2}
                style={{
                  margin: 0,
                  color: TEXT_PRIMARY,
                  fontFamily: "'Quicksand', sans-serif",
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                Meet the Team
              </Title>
            </Space>

            {operationalGroup && (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    marginBottom: 32,
                  }}
                >
                  <div
                    style={{
                      width: 4,
                      height: 32,
                      borderRadius: 2,
                      background: `linear-gradient(180deg, #34d399, ${ACCENT})`,
                      flexShrink: 0,
                    }}
                  />
                  <div>
                    <Title
                      level={3}
                      style={{
                        margin: 0,
                        color: TEXT_PRIMARY,
                        fontFamily: "'Quicksand', sans-serif",
                        fontWeight: 700,
                      }}
                    >
                      {operationalGroup.kategori}
                    </Title>
                    <Text
                      style={{
                        fontSize: 13,
                        color: TEXT_SECONDARY,
                        fontFamily: "'Quicksand', sans-serif",
                      }}
                    >
                      Struktur organisasi pelaksana teknis Kidversa
                    </Text>
                  </div>
                </div>

                <div
                  style={{
                    background: "#fff",
                    borderRadius: 20,
                    padding: "40px 24px 48px",
                    boxShadow: "0 2px 16px rgba(0,0,0,0.05)",
                  }}
                >
                  <OrgChart anggota={operationalGroup.anggota} />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 24,
                    marginTop: 20,
                    flexWrap: "wrap",
                  }}
                >
                  {[
                    { color: ACCENT, label: "CEO & Lead" },
                    { color: TEXT_SECONDARY, label: "Tim Pelaksana" },
                  ].map((item, i) => (
                    <div
                      key={i}
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <div
                        style={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          background: item.color,
                        }}
                      />
                      <Text
                        style={{
                          fontSize: 12,
                          color: TEXT_SECONDARY,
                          fontFamily: "'Quicksand', sans-serif",
                        }}
                      >
                        {item.label}
                      </Text>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {advisorGroup && (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    marginBottom: 32,
                  }}
                >
                  <div
                    style={{
                      width: 4,
                      height: 32,
                      borderRadius: 2,
                      background: `linear-gradient(180deg, ${ACCENT}, #a78bfa)`,
                      flexShrink: 0,
                    }}
                  />
                  <div>
                    <Title
                      level={3}
                      style={{
                        margin: 0,
                        color: TEXT_PRIMARY,
                        fontFamily: "'Quicksand', sans-serif",
                        fontWeight: 700,
                      }}
                    >
                      {advisorGroup.kategori}
                    </Title>
                    <Text
                      style={{
                        fontSize: 13,
                        color: TEXT_SECONDARY,
                        fontFamily: "'Quicksand', sans-serif",
                      }}
                    >
                      Semua penasihat memiliki peran dan kontribusi yang setara
                    </Text>
                  </div>
                </div>

                <div
                  style={{
                    background: "#fff",
                    borderRadius: 20,
                    padding: "32px 24px",
                    boxShadow: "0 2px 16px rgba(0,0,0,0.05)",
                  }}
                >
                  <Flex wrap="wrap" justify="center" gap={32}>
                    {advisorGroup.anggota.map((person, i) => (
                      <AdvisorCard key={i} anggota={person} />
                    ))}
                  </Flex>
                </div>
              </div>
            )}
          </Space>
        </main>

        <FooterSection2 />
      </Flex>
    </>
  );
}

export default About;
